export default __webpack_public_path__ + "static/media/Xarathrustra-minion-particle_0001_Niv.4303d7d6.png";